<!--
 * @Description: 
 * @version: 
 * @Author: m
 * @LastEditors: m
-->
<template>
	<div>
		<van-form>
			<van-field
				v-model="form.sqyt"
				name="申请用途"
				label="申请用途"
				readonly
				value-key="process_name"
			/>
			<van-field v-model="form.start_date" name="借用日期" label="借用日期" readonly />
			<van-field v-model="form.end_date" name="归还日期" label="归还日期" readonly />
			<van-field v-model="form.client_name" name="关联客户" label="关联客户" readonly />
			<van-field v-model="form.remark" rows="3" autosize label="备注" type="textarea" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "cost",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {}
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>